var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClearPromo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.90388 0.298426C9.50594 -0.0995218 8.86068 -0.0994685 8.46267 0.298545L5.1012 3.66001L1.80419 0.362994C1.40624 -0.0349537 0.760987 -0.0349004 0.362974 0.363113C-0.0350395 0.761126 -0.0350928 1.40638 0.362855 1.80433L3.65987 5.10134L0.298545 8.46267C-0.0994688 8.86068 -0.0995218 9.50594 0.298426 9.90388C0.696375 10.3018 1.34163 10.3018 1.73964 9.90377L5.10097 6.54244L8.39808 9.83956C8.79603 10.2375 9.44128 10.2375 9.8393 9.83944C10.2373 9.44143 10.2374 8.79617 9.83942 8.39822L6.5423 5.10111L9.90377 1.73964C10.3018 1.34163 10.3018 0.696373 9.90388 0.298426Z",
    fill: "#C1C1C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearPromo);
export default __webpack_public_path__ + "static/media/clearPromo.db1557b26a3724dec033384ba58d7147.svg";
export { ForwardRef as ReactComponent };